import { Button, Form, Input, Typography } from 'antd'
import React, { useState, useEffect } from 'react'
import LilyButton from '../../../../components/button/lily-button';
import { useNavigate } from 'react-router-dom';
import { useClaimContext } from '../component/claim-context';
import { useSelector } from 'react-redux';

const InputDrug = (props) => {
    const { setStage } = props
    const { Title, Text } = Typography;
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const [errors, setErrors] = useState({
        nameDrug: ''
    });
    const { claimForm, setCurrent, setClaimForm } = useClaimContext();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setClaimForm((prev) => ({
            ...prev,
            copayCardInfo: {
                ...prev.copayCardInfo,
                [name]: value,
            },
        }));
    }

    useEffect(() => {
        form.setFieldsValue({
            programName: claimForm.copayCardInfo.programName || '',
        })
    }, [claimForm])

    const handleSubmit = () => {
        setStage('form');
    }

    return (
        <div className='claim-layout'>
            <div className='d-flex flex-column justify-content-between w-100' style={{ maxWidth: '660px' }}>
                <div className='input-drug-layout'>
                    <div className='d-flex flex-column gap-3'>
                        <Title className='mb-1 main-title' level={3}>
                            Claims Processing
                        </Title>
                        <Text>
                            The following information is needed to be considered for reimbursement. Do not submit claims for any prescription covered under Medicare, Medicaid, CHAMPUS, TRICARE, or any state or federally funded programs, nor for any amount covered by insurance, FSA, or HSA - none of which are eligible for reimbursement.
                        </Text>
                        <Text className='mt-2' style={{ fontSize: '15px' }} strong>All claims must be submitted within 90 days of service.</Text>
                    </div>
                </div>
                <div className='d-flex flex-row justify-content-end'>
                    <Button
                        color="default"
                        variant="link"
                        style={{ width: '200px' }}
                        onClick={() => navigate(-1)}
                    >
                        Back
                    </Button>
                    <LilyButton style={{ width: '200px' }} onClick={handleSubmit} text="Get Started" />
                </div>
            </div>
        </div>
    )
}

export default InputDrug